import { createContext } from "react";

const SetupContext = createContext({} as any);

export default SetupContext;